import React, { useState, useEffect } from "react";
import { collection, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
import { db, auth } from "./firebase";
import { useLanguage } from "./LanguageContext";

function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const { lang } = useLanguage();

  useEffect(() => {
    loadNotifications();
    const interval = setInterval(loadNotifications, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadNotifications = async () => {
    try {
      const user = auth.currentUser;
      if (!user) return;
      const q = query(collection(db, "notifications"), where("recipientId", "==", user.uid));
      const snap = await getDocs(q);
      const results = [];
      snap.forEach((d) => results.push({ id: d.id, ...d.data() }));
      results.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
      setNotifications(results);
    } catch (err) {
      console.error(err);
    }
  };

  const markAsRead = async (notifId) => {
    try {
      await updateDoc(doc(db, "notifications", notifId), { read: true });
      setNotifications(notifications.map((n) => (n.id === notifId ? { ...n, read: true } : n)));
    } catch (err) {
      console.error(err);
    }
  };

  const unreadCount = notifications.filter((n) => !n.read).length;

  return (
    <div style={{ position: "relative" }}>
      <button onClick={() => setOpen(!open)} style={styles.bellButton}>
        {"@"}
        {unreadCount > 0 && <span style={styles.badge}>{unreadCount}</span>}
      </button>

      {open && (
        <div style={styles.dropdown}>
          <div style={styles.dropdownHeader}>
            {lang === "de" ? "Benachrichtigungen" : "Notifications"}
          </div>
          {notifications.length === 0 && (
            <div style={styles.emptyNotif}>
              {lang === "de" ? "Keine Benachrichtigungen." : "No notifications."}
            </div>
          )}
          {notifications.map((n) => (
            <div
              key={n.id}
              onClick={() => markAsRead(n.id)}
              style={n.read ? styles.notifItemRead : styles.notifItemUnread}
            >
              <div style={{ fontSize: 12 }}>{lang === "de" ? n.messageDe : n.messageEn}</div>
              <div style={{ fontSize: 10, color: "#999", marginTop: 2 }}>
                {n.createdAt ? n.createdAt.split("T")[0] : ""}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  bellButton: {
    background: "rgba(255,255,255,0.2)",
    color: "#fff",
    border: "none",
    padding: "8px 10px",
    borderRadius: 8,
    fontSize: 13,
    fontWeight: 700,
    cursor: "pointer",
    position: "relative",
  },
  badge: {
    position: "absolute",
    top: -4,
    right: -4,
    background: "#c62828",
    color: "#fff",
    borderRadius: "50%",
    width: 16,
    height: 16,
    fontSize: 9,
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dropdown: {
    position: "absolute",
    top: 40,
    right: 0,
    width: 260,
    maxHeight: 300,
    overflowY: "auto",
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
    zIndex: 100,
  },
  dropdownHeader: {
    padding: "10px 14px",
    fontWeight: 700,
    fontSize: 12,
    color: "#333",
    borderBottom: "1px solid #eee",
  },
  emptyNotif: {
    padding: "20px 14px",
    fontSize: 12,
    color: "#999",
    textAlign: "center",
  },
  notifItemUnread: {
    padding: "10px 14px",
    borderBottom: "1px solid #f0f0f0",
    background: "#f0f6ff",
    cursor: "pointer",
    color: "#222",
  },
  notifItemRead: {
    padding: "10px 14px",
    borderBottom: "1px solid #f0f0f0",
    background: "#fff",
    cursor: "pointer",
    color: "#666",
  },
};

export default NotificationBell;
